'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('payment-plan-list', {
      url: '/user/payment/plan/list',
      template: '<payment-plan-list></payment-plan-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/payment/plan-list/payment-plan-list.routes.js